export type DeviceType =
  | "ipad"
  | "iphone"
  | "mac"
  | "android_phone"
  | "android_tablet"
  | "windows_touch"
  | "windows"
  | "unknown";

export function detectDevice(): DeviceType {
  const ua = navigator.userAgent ?? "";
  const platform = navigator.platform ?? "";
  const maxTouch = navigator.maxTouchPoints ?? 0;

  // iPad — must come before Mac check, since modern iPads report platform as "MacIntel"
  if (platform === "MacIntel" && maxTouch > 0) return "ipad";

  if (platform.startsWith("Mac")) return "mac";

  if (/iPhone/.test(ua)) return "iphone";

  if (/Android/.test(ua)) {
    return Math.min(window.screen.width, window.screen.height) >= 600 ? "android_tablet" : "android_phone";
  }

  // Deliberately not "tablet": Windows tablets and touch laptops both report Win32 + touch points
  // and cannot be told apart.
  if (platform.startsWith("Win") && maxTouch > 0) return "windows_touch";

  if (platform.startsWith("Win")) return "windows";

  return "unknown";
}
